import { MessagingDetailsCard } from "@/components/atoms/interactionDetailsCard";
import { acceptEmailConversation, acceptEmailConversationTransfer, rejectEmailConversation, rejectEmailConversationTransfer } from "@/repository/queryFns";
import { Mail20Regular } from "@fluentui/react-icons";
import { InteractionCardBase } from "./InteractionBase";
import { ChannelType } from "@/common/constants/shared";

const emailConfig = {
    icon: <Mail20Regular />,
    detailsCard: MessagingDetailsCard,
    acceptFn: acceptEmailConversation,
    acceptTransferFn: acceptEmailConversationTransfer,
    rejectFn: rejectEmailConversation,
    rejectTransferFn: rejectEmailConversationTransfer,
    messageIntlId: "Interaction.Contents.EmailMessage",
}

export const EmailInteractionCard = () => {
    return (
        <InteractionCardBase channelType={ChannelType.Email} channelConfig={emailConfig} />
    );
};